export const DEFAULT_SAMPLE_SIZE = 100;
export const CACHE_DURATION_MS = 5 * 60 * 1000;
export const SESSIONS_PAGE_SIZE = 5;
export const EXPORT_BATCH_LIMIT = 999999;
export const SESSIONS_BASE_URL = '/api/experiences/user-sessions';
export const ANALYTICS_SESSIONS_BASE_URL = '/api/analytics/sessions';
export const SESSIONS_BY_DATE_ENDPOINT = '/api/analytics/sessions/by-date';
export const SEARCH_DEBOUNCE_MS = 500;
export const STAT_VALUE_PRECISION = 1;
